// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_FACET_CATEGORY = "Kateg\u00f3ria";
export const BZ2_SEARCH_BUTTON = "H\u013eadaj";
export const BZ2_SUGGEST_CATEGORY_CATEGORY = "Odpor\u00fa\u010dan\u00e9 kateg\u00f3rie";
export const PRODUCT_CREATE_EDIT_FORM_I_WANT_TO_PICK_CATEGORY_MANUALLY = "Chcem vybra\u0165 in\u00fa kateg\u00f3riu, uk\u00e1\u017e mi v\u0161etky...";
export const PRODUCT_CREATE_EDIT_FORM_LOADING_SUGGESTIONS = "H\u013ead\u00e1m kateg\u00f3riu...";
